/**
 * The retro kit's prompt (slice 6b): one word (`ui.prompt.talk`, `read`,
 * `enter`, `wish`, `shop`, `descend`) in a small panel at the bottom right
 * while something the traveler can use is in reach. On a keyboard device the
 * key (`ui.prompt.key`, E) shows before the word; on touch nothing more (the
 * pad's centre is the action). The panel is a 44 px button: a tap acts.
 */
import type { Strings } from '@ab/session';
import { Panel } from './panel.tsx';
import { text } from './text.ts';
import './ui.css';

export type PromptProps = {
  readonly strings: Strings;
  /** The prompt's key (`ui.prompt.<kind>`); null hides it. */
  readonly word: string | null;
  /** Show the key before the word (a keyboard device). */
  readonly keyHint: boolean;
  readonly onAct: () => void;
};

export const Prompt = ({ strings, word, keyHint, onAct }: PromptProps) =>
  word === null ? null : (
    <Panel placement="prompt" className="ab-prompt" data-testid="prompt">
      <button
        type="button"
        className="ab-prompt-button"
        onClick={() => {
          onAct();
        }}
      >
        {keyHint && (
          <kbd className="ab-prompt-key" data-testid="prompt-key">
            {text(strings, 'ui.prompt.key')}
          </kbd>
        )}
        <span data-testid="prompt-word">{text(strings, word)}</span>
      </button>
    </Panel>
  );
